@if (canEdit) {
<div class="ep-wizard-container">
  @if (!showWizard) {
  <div class="ep-wizard-intro">
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="startWizard()"
      [disabled]="!userUuid"
    >
      <mat-icon>school</mat-icon>
      Administrer uddannelsesveje
    </button>
    @if (!userUuid) {
    <p class="hint">Indlæser bruger…</p>
    }
  </div>
  } @if (showWizard) {
  <mat-card class="ep-wizard-card">
    <mat-card-header>
      <mat-card-title>Tilknyt uddannelsesveje</mat-card-title>
      <mat-card-subtitle
        >Vælg version og startdatoer for brugeren</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      @if (loading) {
      <div class="loading-row">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="40"
        ></mat-progress-spinner>
        <span>Henter uddannelsesveje…</span>
      </div>
      } @if (error) {
      <div class="error-banner">{{ error }}</div>
      } @if (!loading) {
      <mat-stepper linear #stepper>
        <mat-step [stepControl]="datesForm" label="Startdatoer">
          <form [formGroup]="datesForm" class="dates-form">
            <mat-form-field appearance="outline">
              <mat-label>Start dato for uddannelse</mat-label>
              <input
                matInput
                type="date"
                formControlName="requirement_started_at"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Start dato for vedligeholdelse</mat-label>
              <input
                matInput
                type="date"
                formControlName="maintenance_started_at"
              />
            </mat-form-field>
            <p class="hint">
              Hvis ikke angivet, bruges 01/01/2023 som standard.
            </p>
          </form>
          <div class="step-actions">
            <button mat-button type="button" (click)="cancelWizard()">
              Annuller
            </button>
            <button
              mat-raised-button
              color="primary"
              matStepperNext
              type="button"
            >
              Næste
            </button>
          </div>
        </mat-step>
        <mat-step label="Vælg veje">
          <p class="hint">
            Vælg én eller flere uddannelsesveje. Kun én version per vej.
          </p>
          @if (pathRows.length) {
          <table mat-table [dataSource]="pathRows" class="paths-table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  [checked]="row.selected"
                  (change)="toggleRow(row, $event.checked)"
                  [disabled]="!row.path.versions?.length"
                ></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Uddannelsesvej</th>
              <td mat-cell *matCellDef="let row">{{ getPathLabel(row) }}</td>
            </ng-container>
            <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef>Version</th>
              <td mat-cell *matCellDef="let row">
                @if (row.selected && row.path.versions?.length) {
                <mat-form-field appearance="outline" class="version-field">
                  <mat-select
                    [value]="row.version_id"
                    (selectionChange)="onVersionChange(row, $event.value)"
                  >
                    @for (v of (row.path.versions ?? []); track v) {
                    <mat-option [value]="v.version_id">
                      {{ v.display_name }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                } @if (row.selected && !row.path.versions?.length) {
                <span class="warn-text">Ingen versioner</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let row">
                <span [class.existing-badge]="row.isExisting">{{
                  getRowStatus(row)
                }}</span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          } @if (!pathRows.length) {
          <p class="hint">Ingen uddannelsesveje fundet for organisationen.</p>
          }
          <div class="step-actions">
            <button mat-button type="button" matStepperPrevious>Tilbage</button>
            <button
              mat-raised-button
              color="primary"
              matStepperNext
              type="button"
              [disabled]="!hasValidSelection"
            >
              Næste
            </button>
          </div>
        </mat-step>
        <mat-step label="Gennemse">
          <div class="review-section">
            <h3>Startdatoer</h3>
            <ul>
              <li>Uddannelse: {{ datesForm.value.requirement_started_at }}</li>
              <li>
                Vedligeholdelse: {{ datesForm.value.maintenance_started_at }}
              </li>
            </ul>
            <h3>Valgte uddannelsesveje ({{ selectedRows.length }})</h3>
            <ul>
              @for (row of selectedRows; track row) {
              <li>
                {{ getPathLabel(row) }}
                — {{ getVersionLabel(row) }}
                @if (row.isExisting) {
                <span>(opdateres)</span>
                }
              </li>
              }
            </ul>
          </div>
          <div class="step-actions">
            <button
              mat-button
              type="button"
              matStepperPrevious
              [disabled]="submitting"
            >
              Tilbage
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="submit()"
              [disabled]="submitting || !hasValidSelection"
            >
              @if (submitting) {
              <mat-progress-spinner
                mode="indeterminate"
                diameter="20"
                class="btn-spinner"
              ></mat-progress-spinner>
              } @if (!submitting) {
              <span>Gem tilknytninger</span>
              }
            </button>
          </div>
        </mat-step>
      </mat-stepper>
      }
    </mat-card-content>
  </mat-card>
  }
</div>
}
